<template>
  <div
    v-if="description"
    :class="{
        'dh-psy-data-viz__description-item': true,
        'dh-psy-data-viz__description-item--left': align === 'left',
        'dh-psy-data-viz__description-item--right': align === 'right'
      }"
  >
    <span
      v-if="altText"
      class="nrk-sr"
      v-html="altText"
    />
    <p v-html="description" />
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: 'right'
    },
    description: {
      type: String,
      required: true
    },
    altText: {
      type: [String, undefined],
      required: false,
      default: undefined
    }
  }
}
</script>

<style scoped lang="postcss">
  :global(.dh-no-backdrop-filter) .dh-psy-data-viz__description-item p {
    background: rgba(255, 255, 255, 0.97);
  }

  .dh-psy-data-viz__description-item {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: calc(1em + 0.1vw);
    font-family: NRK Etica Slab;
    line-height: 1.6;
    width: calc(100% - 2em);

    & p {
      max-width: 450px;
      padding: 0 0 24px;
      background: rgba(255, 255, 255, 0.85);
      -webkit-backdrop-filter: blur(6px);
      backdrop-filter: blur(6px);
      box-sizing: border-box;
      margin: 0;
    }

    & :global(span) {
      font-weight: bold;
      color: #14a081;
    }

    & :global(.red) {
      color: #e51c30;
    }

    & :global(cite) :global(small) {
      display: inline-block;
      font-style: normal;
      font-family: LFT Etica;
      font-weight: 400;
      font-size: 0.8em;
      max-width: 60%;
      margin: 20px auto auto 1em;
      line-height: 0.8em;
      background: #8debd6;
    }

    @media (min-width: 450px) {
      font-size: calc(1.1em + 0.1vw);
    }

    @media (min-width: 650px) {
      font-size: calc(1.3em + 0.1vw);
    }

    @media (min-width: 800px) {
      &.dh-psy-data-viz__description-item--left {
        justify-content: center;
      }
      &.dh-psy-data-viz__description-item--right {
        justify-content: center;
      }

      width: 50%;
      padding: 18px;
      font-size: calc(1.4em + 0.1vw);
    }
  }

  :global(.dh-psy-data-viz--series) {
    & :global(.dh-psy-data-viz__description--small) .dh-psy-data-viz__description-item {
      @media (max-width: 800px) {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
      }
    }

    & .dh-psy-data-viz__description-item {
      margin-bottom: 65vh;
      margin-bottom: calc(65 * var(--dh-vh));
      width: 100%;

      &:last-of-type {
        margin-bottom: 15vh;
        margin-bottom: calc(15 * var(--dh-vh));
      }

      & p {
        padding: 18px 24px;
      }

      @media (min-width: 800px) {
        max-width: 100%;

        &:first-of-type {
          margin-top: -50vh;
          margin-top: calc(-50 * var(--dh-vh));
        }
        &:last-of-type {
          margin-bottom: 0;
        }

        &.dh-psy-data-viz__description-item--left {
          justify-content: flex-start;
        }

        &.dh-psy-data-viz__description-item--right {
          justify-content: flex-end;
        }

        & p {
          width: 45%;
          padding: 18px 0;
        }
      }
    }
  }
</style>
